import { Check, Pencil, Plus, RotateCcw, X } from 'lucide-react';

// The icons of a history's steps, all of one set (lucide) and one size: drawn
// on the same grid with the same stroke, they look alike in their circles.
const icon = (Icon) => <Icon size={16} aria-hidden="true" />;

const ACTIVITY_ICONS = {
  created: icon(Plus),
  done: icon(Check),
  reopened: icon(RotateCcw),
  updated: icon(Pencil),
  canceled: icon(X),
};

export default ACTIVITY_ICONS;
